module.exports = __webpack_public_path__ + "static/media/sample_branches.5018f73d.csv";